"use strict";

exports.__esModule = true;
exports["default"] = exports.PaneShieldIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _elements = require("../../components/glyphs/elements");

var _primitives = _interopRequireDefault(require("../../primitives"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PaneShieldIcon = (0, _styledComponents["default"])(_elements.Shield).withConfig({
  displayName: "panel-title__PaneShieldIcon",
  componentId: "sc-16dsj34-0"
})(["width:100%;height:100%;"]);
exports.PaneShieldIcon = PaneShieldIcon;
var PaneTitle = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "panel-title__PaneTitle",
  componentId: "sc-16dsj34-1"
})(["display:inline-flex;"]);
var propTypes = {
  /** boolean to display icon representing restriction */
  isRestricted: _propTypes.bool,

  /** panel Title text */
  paneTitle: _propTypes.string
};

var ResultsPanePanelTitle = function ResultsPanePanelTitle(_ref) {
  var isRestricted = _ref.isRestricted,
      paneTitle = _ref.paneTitle;
  return /*#__PURE__*/_react["default"].createElement(PaneTitle, {
    color: "gray-dark",
    fontSize: [5, 6],
    fontWeight: [1],
    letterSpacing: ["0.3px"],
    tag: "h1"
  }, isRestricted && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    mr: 8,
    width: 24
  }, /*#__PURE__*/_react["default"].createElement(PaneShieldIcon, null)), paneTitle);
};

ResultsPanePanelTitle.propTypes = propTypes;
ResultsPanePanelTitle.displayName = "Modules.PanelTitle";
var _default = ResultsPanePanelTitle;
exports["default"] = _default;